import { useEffect, useState } from 'react';
import { useGetIdLanguage } from '../HookLanguageSelector/useGetIdLnaguage';
import { HttpClient } from '../../../Domain/Utils/ApiUtilies/Fetch/Fetch';
import { API_REFERENCE_TYPE } from '../../../Domain/Redux/Paths';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';

const useGetReferenceTypeList = () => {
  const language = useGetIdLanguage();
  const [referenceTypeList, setReferenceTypeList] = useState([]);

  const getReferenceType = async () => {
    try {
      const response = await HttpClient.GET(API_REFERENCE_TYPE, {
        component: COMPONENTS.REFERENCE_TYPES,
        multilanguage_id: language
      });
      if (response?.content?.length > 0) {
        setReferenceTypeList(response?.content);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (!language) return;
    getReferenceType();
  }, [language]);

  return { referenceTypeList };
};

export default useGetReferenceTypeList;
